import React from 'react';
import './RefundPolicyPage.css';

/**
 * RefundPolicyPage Component
 * 
 * This component renders the Refund & Cancellation Policy page for Ummeed ki Kiran Foundation.
 * It displays the organization's policy regarding donations, event registrations, merchandise,
 * and procedures for handling donation errors.
 * 
 * @returns {JSX.Element} The refund policy page component
 */
const RefundPolicyPage = () => {
    return (
        <div className="refund-policy-page">
            <div className="refund-policy-container">
                <div className="refund-policy-content">
                    <header className="refund-policy-header">
                        <h1>Refund & Cancellation Policy</h1>
                        <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
                    </header>

                    <div className="refund-policy-body">
                        <section className="policy-section">
                            <p>
                                Thank you for supporting Ummeed ki Kiran Foundation. Your contribution helps us continue our mission of providing education, healthcare, and support to underprivileged communities.
                            </p>
                            <p>
                                As a non-profit organization, we operate based on the generosity of our donors and supporters. To maintain transparency and ensure resources are directed effectively towards our programs, we have established the following policy:
                            </p>
                        </section>

                        <section className="policy-section">
                            <h2>Donations</h2>
                            <ul>
                                <li>All donations made to Ummeed ki Kiran Foundation are final and non-refundable.</li>
                                <li>Once a donation has been processed, it cannot be canceled, returned, or refunded, regardless of the payment method.</li>
                            </ul>
                        </section>

                        <section className="policy-section">
                            <h2>Event Registrations / Tickets (if applicable)</h2>
                            <ul>
                                <li>Contributions made for event registrations or tickets are considered as donations to Ummeed ki Kiran Foundation.</li>
                                <li>Cancellations are not eligible for refunds.</li>
                            </ul>
                        </section>

                        <section className="policy-section">
                            <h2>Merchandise Purchases (if applicable)</h2>
                            <ul>
                                <li>Merchandise sales are final. Returns, exchanges, or refunds will not be accepted.</li>
                            </ul>
                        </section>

                        <section className="policy-section">
                            <h2>Errors in Donation</h2>
                            <p>
                                If you believe an error has occurred in your donation transaction (e.g., duplicate donation, incorrect amount), please contact us immediately at support@ummeedkikiran.org. We will review the matter and resolve it at our discretion.
                            </p>
                        </section>

                        <section className="policy-section">
                            <h2>Contact Us</h2>
                            <p>For any questions regarding this policy, please contact:</p>
                            <div className="contact-info">
                                <p><strong>Ummeed ki Kiran Foundation</strong></p>
                                <p><strong>Email:</strong> <a href="mailto:support@ummeedkikiran.org">support@ummeedkikiran.org</a></p>
                                <p><strong>Phone:</strong> <a href="tel:+917985947303">+917985947303</a></p>
                            </div>
                        </section>
                    </div>

                    <div className="refund-policy-footer">
                        <p>
                            By making a donation to our organization, you acknowledge that you have read and understood this Refund & Cancellation Policy and agree to its terms.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RefundPolicyPage;